import { LayoutOverlayRect } from './layout-overlay-rect.interface';

/**
 * Height of the viewport bottom covered by fixed overlays (bottom navigation, pinned banners).
 * In-flow or collapsed elements do not cover the viewport and are ignored.
 */
export function getBottomOverlayHeight(viewportHeight: number, overlays: LayoutOverlayRect[]): number {
  return overlays
    .filter(overlay => overlay.isFixed && overlay.height > 0)
    .reduce((coveredHeight, overlay) => Math.max(coveredHeight, viewportHeight - overlay.top), 0);
}
